<template>
  <div>
    <div class="px-4 py-1" style="border-bottom: 1px solid rgba(128, 143, 156, 0.2)">
      <v-row class="pa-0">
        <v-col cols="7" class="pa-0">
          <div class="record-body" :class="boldClass">{{record.title}}</div>
          <div class="text-grey" style="font-size: 12px">
            <div class="float-left mr-1 impact" :class="record.impact"></div>
            <div class="float-left mr-1">{{newsTime}}</div>
            <div class="float-left mr-1">| {{record.symbol}}</div>
          </div>
        </v-col>
        <v-col cols="5" class="pa-0 text-right">
          <v-row class="pt-1 pr-2">
            <v-col cols="4" class="pa-0">
              <span
                class="text-grey"
                style="font-size: 12px"
                :class="record.actualColor"
              >{{record.actual}}</span>
            </v-col>

            <v-col cols="4" class="pa-0">
              <span class="text-grey" style="font-size: 12px">{{record.forecast}}</span>
            </v-col>

            <v-col cols="4" class="pa-0">
              <span
                class="text-grey"
                style="font-size: 12px"
                :class="record.previousColor"
              >{{record.previous}}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
var moment = require("moment-timezone");
export default {
  name: "MacroItem",
  components: {},
  props: ["record","index"],
  data() {
    return {
      countDown: null,
      newsTime: null,
      boldClass: "",
      titleClass: "",
      timeDiff: null
    };
  },
  mounted() {
    this.updateTimes();
    setInterval(() => {
      this.updateTimes();
    }, 1000);
  },
  methods: {
    updateTimes() {
      var a = moment();
      var b = moment(this.record.dateTime);

      this.timeDiff = b.diff(a, "minutes");
      //var timeDiff2 = b.diff(a, "seconds");

      if (this.timeDiff <= 15 && this.timeDiff >= -5) {
        this.boldClass = "next-macro";
        //var cnt = moment.duration(timeDiff2 * 60 *1000, 'milliseconds');
        //this.countDown = cnt.minutes() + ":" + cnt.seconds()
      } else this.boldClass = "";

      if (this.timeDiff < -2) {
        this.boldClass = "passed";
      }

      
      if (this.record.time.split(":").length > 1) {
        this.newsTime = moment
          .tz(this.record.dateTime, this.$store.getters.timezone)
          .format("HH:mm");
      } else this.newsTime = this.record.time;
      
    }
  }
};
</script>

<style scoped>
.better {
  color: #79c04d;
}

.worse {
  color: #e62163;
}

.next-macro {
  font-weight: bold;
  color:#e62163;
  /*color: #25a7f9;*/
  
}
.passed {
  color: #808f9c;
}

.impact {
  background-color: grey;
  border-radius: 49%;
  min-width: 15px;
  min-height: 15px;
}
.low {
  background-color: rgba(255, 255, 0, 0.3);
}
.medium {
  background-color: rgba(255, 140, 0, 0.3);
}
.high {
  background-color: rgba(255, 0, 0, 0.3);
}
</style>